// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoreOutlinedSvg from "@fishx/icons-svg/es/asn/MoreOutlined";
import FishxIcon from '../components/FishxIcon';

var MoreOutlined = function MoreOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoreOutlinedSvg
  }));
};

MoreOutlined.displayName = 'MoreOutlined';
export default React.forwardRef(MoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MoreOutlined.js
// module id = 3161
// module chunks = 0